module.exports = __webpack_public_path__ + "OnePlus_6.svg?fd2254e45c0c34fd2ddffb26b9144eea";


//////////////////
// WEBPACK FOOTER
// ./src/assets/devices/OnePlus_6.svg
// module id = 204
// module chunks = 0